import PropTypes from "prop-types";
import { memo } from "react";

import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { useCurrentFormatCurrency } from "@hooks/usePrices";

function LineItemPrice({ variant, isLuxe, isGiftProduct }) {
  const formatCurrency = useCurrentFormatCurrency();

  if (variant?.final_price == null || variant?.full_price == null) {
    return null;
  }

  const finalPrice = isLuxe ? variant.final_price_luxe : variant.final_price;
  const isDiscounted = finalPrice < variant.full_price;

  return (
    <div className="typo-body-bold text-right">
      {isDiscounted || isGiftProduct ? (
        <>
          <p className="strikethrough mb-[3px]">{formatCurrency(variant.full_price)}</p>
          <p className="text-secondary">{isGiftProduct ? "FREE" : formatCurrency(finalPrice)}</p>
        </>
      ) : (
        <p>{formatCurrency(finalPrice)}</p>
      )}
    </div>
  );
}

LineItemPrice.propTypes = {
  variant: PropTypes.shape({
    final_price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    full_price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    final_price_luxe: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isLuxe: PropTypes.bool,
  isGiftProduct: PropTypes.bool,
};

export default withALErrorBoundary({
  name: "LineItemPrice",
  priority: "P1",
})(memo(LineItemPrice));
